var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcoParentalRating16 = function SvgIcoParentalRating16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FC0",
    d: "M12 24c6.628 0 12-5.372 12-12 0-6.627-5.372-12-12-12S0 5.373 0 12c0 6.628 5.372 12 12 12"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M9.567 8.486h-1.3c-.492 0-.738.374-.738.738 0 .365.246.739.739.739h.501v4.746c0 .561.335.847.798.847s.798-.286.798-.847V9.283c0-.66-.434-.797-.798-.797M14.276 11.026c-.296 0-.474.03-.622.08l-.018-.02c.717-1.055 1.486-1.468 1.486-1.99 0-.266-.236-.767-.77-.767-.382 0-.639.196-1.82 1.663-.69.857-1.39 2-1.39 3.269 0 1.418.995 2.393 2.552 2.393 1.507 0 2.55-1.064 2.55-2.432 0-1.102-.806-2.196-1.969-2.196m-.582 3.092a.906.906 0 0 1-.897-.896c0-.482.404-.896.897-.896.492 0 .896.414.896.896a.906.906 0 0 1-.896.896"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M12.032 4.797c3.967 0 7.196 3.23 7.196 7.197 0 3.969-3.229 7.197-7.196 7.197-3.969 0-7.198-3.228-7.198-7.197s3.229-7.197 7.198-7.197m0-2.398a9.595 9.595 0 0 0-9.597 9.595c0 5.3 4.296 9.596 9.597 9.596 5.299 0 9.595-4.296 9.595-9.596S17.331 2.4 12.032 2.4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgIcoParentalRating16;